import { Stack, Text } from "@certn/cascadia";
import {
  ButtonGroup,
  BasicButton,
  PrimaryButton,
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
} from "@certn/cascadia-react";
import { Dispatch, SetStateAction } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useHandleChange } from "../../utils";

export function SkipDSConsentModal({
  setOnSkipConsent,
  consentKey = "ds_consent",
}: {
  setOnSkipConsent: Dispatch<SetStateAction<boolean>>;
  consentKey?: string;
}) {
  const { t } = useTranslation();
  const handleChange = useHandleChange();

  return (
    <Modal testID="skip-ds-consent-modal">
      <Dialog>
        {({ close }) => (
          <>
            <DialogHeader onClose={close} testID="skip-ds-consent-modal-header">
              {t("Opt out of Disclosure Scotland consent")}
            </DialogHeader>
            <DialogContent testID="skip-ds-consent-modal-content">
              <Stack gap="space-4">
                <Text style="global/body-primary">
                  <Trans>
                    By opting out of Disclosure Scotland consent, Certn will be
                    unable to submit your information to Disclosure Scotland.
                    This may affect the progress or outcome of your application.
                  </Trans>
                </Text>
                <Text style="global/body-primary">
                  <Trans>Are you sure you want to opt out?</Trans>
                </Text>
              </Stack>
            </DialogContent>
            <DialogFooter testID="skip-ds-consent-modal-footer">
              <ButtonGroup>
                <BasicButton
                  size="medium"
                  onPress={() => {
                    close();
                  }}
                  testID="skip-ds-consent-cancel-button"
                >
                  <Trans>Cancel</Trans>
                </BasicButton>
                <PrimaryButton
                  testID="skip-ds-consent-continue-button"
                  size="medium"
                  onPress={() => {
                    handleChange(
                      `${consentKey}.has_read_privacy_policy`,
                      false
                    );
                    handleChange(
                      `${consentKey}.has_authorized_certn_to_submit_application`,
                      false
                    );
                    handleChange(
                      `${consentKey}.has_consented_to_certn_viewing_certificate`,
                      false
                    );
                    setOnSkipConsent(true);
                    close();
                  }}
                >
                  <Trans>Opt out</Trans>
                </PrimaryButton>
              </ButtonGroup>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
